import { render, staticRenderFns } from "./Booked.vue?vue&type=template&id=a966d706"
import script from "./Booked.vue?vue&type=script&lang=js"
export * from "./Booked.vue?vue&type=script&lang=js"
import style0 from "./Booked.vue?vue&type=style&index=0&id=a966d706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports